/**
 * Visible 404. Replaces the catch-all `<Navigate to="/dashboard" />`, which
 * made every unknown URL look like the home page.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';

const NotFoundPage = () => (
  <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-4 text-center" data-testid="not-found">
    <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-slate-200">
      <FileQuestion className="h-8 w-8 text-slate-600" aria-hidden="true" />
    </div>
    <h1 className="mb-2 text-2xl font-bold text-slate-900">404 — Not Found</h1>
    <p className="mb-6 max-w-md text-slate-500">
      This page does not exist. Check the address, or go back to the dashboard.
    </p>
    <Link
      to="/dashboard"
      className="inline-flex items-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
      data-testid="not-found-dashboard-link"
    >
      Back to dashboard
    </Link>
  </div>
);

export default NotFoundPage;
